import { gql } from '@apollo/client';

export default gql`
  query GetScheduleItem($itemSlug: String! = "", $slug: String! = "") {
    schedules(filters: { slug: { eq: $slug } }) {
      scheduleItem(filters: { slug: { eq: $itemSlug } }) {
        image {
          url
        }
        description_ck
      }
    }
  }
`;
